import { useScrollProgress } from '@/lib/hooks';

/**
 * The reading-progress bar, built here so Phase 9's article page assembles rather than
 * improvises (Phase 7 task list: "ready for Phase 9").
 *
 * It is `aria-hidden`: the information it carries — how far down the page you are — is
 * already available to a screen reader through the document itself, and a live region
 * reporting "37%" on every scroll frame would be unusable.
 */
export function ReadingProgress() {
  const { progress } = useScrollProgress();

  return (
    <div aria-hidden="true" className="sticky top-0 z-30 h-0.5 w-full bg-transparent">
      <div
        className="h-full bg-red transition-[width] duration-150"
        style={{ width: `${Math.round(progress * 100)}%` }}
      />
    </div>
  );
}
